import * as React from "react";
import { NavMenu } from "@/components/navigation/NavMenu";
import { NavUser } from "@/components/navigation/NavUser";
import { FirmSwitcher } from "@/components/navigation/FirmSwitcher";
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarRail } from "@/components/ui/sidebar";
import { Link } from "react-router";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader className="p-0">
        <Link to="/">
          <div className="flex items-center justify-center h-[64px] bg-transparent">
            <img src="/logo.svg" alt="Logo" className="h-[50px] object-contain" />
          </div>
        </Link>
        <FirmSwitcher />
      </SidebarHeader>
      <SidebarContent>
        <NavMenu />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
